import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Plus } from 'lucide-react';

const CreateEventDialog = ({ open, onOpenChange, formData, onFormChange, onSubmit }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button
          data-testid="create-event-button"
          className="bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700 text-white shadow-lg hover:shadow-xl h-10 sm:h-12 transition-all duration-200 w-full sm:w-auto text-sm sm:text-base"
        >
          <Plus className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
          <span className="hidden sm:inline">Nouvel Événement</span>
          <span className="sm:hidden">Nouveau</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-white border border-gray-200 text-gray-900">
        <DialogHeader>
          <DialogTitle className="text-xl text-gray-900 font-bold">Créer un événement</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="event-name" className="text-gray-700 text-sm mb-2 block font-medium">Nom de l'événement</Label>
            <Input
              id="event-name"
              data-testid="event-name-input"
              value={formData.name}
              onChange={(e) => onFormChange({ ...formData, name: e.target.value })}
              className="bg-gray-50 border border-gray-200 text-gray-900 placeholder:text-gray-400 focus:border-violet-500 focus:ring-violet-500/30 transition-all duration-200"
              placeholder="Remise de diplôme 2025"
              required
            />
          </div>
          <div>
            <Label htmlFor="event-date" className="text-gray-700 text-sm mb-2 block font-medium">Date</Label>
            <Input
              id="event-date"
              data-testid="event-date-input"
              type="date"
              value={formData.date}
              onChange={(e) => onFormChange({ ...formData, date: e.target.value })}
              className="bg-gray-50 border border-gray-200 text-gray-900 focus:border-violet-500 focus:ring-violet-500/30 transition-all duration-200"
              required
            />
          </div>
          <div>
            <Label htmlFor="event-location" className="text-gray-700 text-sm mb-2 block font-medium">Lieu (optionnel)</Label>
            <Input
              id="event-location"
              data-testid="event-location-input"
              value={formData.location}
              onChange={(e) => onFormChange({ ...formData, location: e.target.value })}
              className="bg-gray-50 border border-gray-200 text-gray-900 placeholder:text-gray-400 focus:border-violet-500 focus:ring-violet-500/30 transition-all duration-200"
              placeholder="Grande salle"
            />
          </div>
          <Button
            data-testid="submit-event-button"
            type="submit"
            className="w-full bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700 text-white shadow-md hover:shadow-lg transition-all duration-200"
          >
            Créer l'événement
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CreateEventDialog;
